<ion-content>
  <ion-grid class="ion-no-padding" style="height: 90%">
    <ion-row
      class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
      style="height: 100%; flex-direction: column"
    >
      <div class="logo-web">
        <ion-img [src]="appLogo"></ion-img>
      </div>
      <div style="width: 95%">
        <ion-card class="ion-margin-bottom no-shadow ion-text-center bg-trans">
          <ion-card-title
            class="fs-4 ion-padding-top font500 marh20 title-text-color"
          >
            {{ loginText }}
          </ion-card-title>
          <ion-card-subtitle class="ion-padding fs-4 font500 title-text-color">
            Login to view your 
            <span *ngIf="PageType !== 'account'">booking details</span>
            <span *ngIf="PageType === 'account'">account details</span>
          </ion-card-subtitle>
          <ion-button
            (click)="verifyLogin()"
            routerDirections="forward"
            expand="block"
            class="primary-btn fs-4 font500 ion-margin-top"
          >
            Login
          </ion-button>
          <ion-button
            (click)="navigateToHome()"
            routerDirections="forward"
            expand="block"
            class="outline-btn fs-4 font500 ion-margin-top"
          >
            Explore as Guest
          </ion-button>
          <div class="quick-links">
            <ion-grid class="ion-no-padding">
              <ion-row class="ion-justify-content-between ion-align-items-center">
                <ion-col size="3" class="ion-text-center">
                  <a routerLink="/about-us" class="quick-link-anchor">About Us</a>
                </ion-col>
                <ion-col size="3" class="ion-text-center">
                  <a routerLink="/terms-and-condition" class="quick-link-anchor">Terms & Conditions</a>
                </ion-col>
                <ion-col size="3" class="ion-text-center">
                  <a routerLink="/privacy-policy" class="quick-link-anchor">Privacy Policy</a>
                </ion-col>
                <ion-col size="3" class="ion-text-center">
                  <a routerLink="/contact-us" class="quick-link-anchor">Contact Us</a>
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-card>
      </div>
    </ion-row>
  </ion-grid>
</ion-content>